//class="min-h-[calc(100vh-var(--ui-header-height))]"
<template>
  <section
    class="
      grid
      lg:grid-cols-[minmax(20rem,_calc(50%_-_20rem))_minmax(0,_60rem)]
      min-h-[calc(100vh-var(--ui-header-height)-var(--application-page-header-height-sm))]
      md:min-h-[calc(100vh-var(--ui-header-height)-var(--application-page-header-height-md))]
      lg:min-h-[calc(100vh-var(--ui-header-height)-var(--application-page-header-height-lg))]
      xl:min-h-[calc(100vh-var(--ui-header-height)-var(--application-page-header-height-xl))]
      2xl:min-h-[calc(100vh-var(--ui-header-height)-var(--application-page-header-height-2xl))]
   "
  >
    <slot />
  </section>
</template>
